import React from "react";
import { cleanJoin } from "../../utils/stringUtil";

function Column({ size, children, className, ...rest }) {
  return (
    <div className={cleanJoin("column", size ? `is-${size}` : "", className)} {...rest}>
      {children}
    </div>
  );
}

export default Column;
